import React from 'react';
import { toDate, format } from 'date-fns-tz';

export type WhatsNewItemViewProps = {
  title?: string;
  text: string;
  date: string;
  excludeHr: boolean;
};

export const WhatsNewItemView = (props: WhatsNewItemViewProps): JSX.Element => {
  const { date, text, title, excludeHr } = props;
  return (
    <>
      {date ? <h2 className={'margin-bottom-small-16'}>{format(toDate(date), 'd MMMM yyyy')}</h2> : null}
      {!!title ? <h3 className={'margin-bottom-small-16'}>{title}</h3> : null}
      <div dangerouslySetInnerHTML={{ __html: text }} />
      {excludeHr ? null : <hr />}
    </>
  );
};
